import './ItemOption.2e132ee21724e9c0a9d025e8fb19f456.css';
export default {"folderLabel":"_folderLabel_4zyrq_1"};